module.exports = __webpack_public_path__ + "static/media/pluralsight_logo.8be49345.png";